import { render } from "./SupportLink.vue?vue&type=template&id=aebf0e1a"
import script from "./SupportLink.vue?vue&type=script&lang=js"
export * from "./SupportLink.vue?vue&type=script&lang=js"

import exportComponent from "/home/jeim2750/develop.fuelguide.be/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__